module.exports = __webpack_public_path__ + "static/media/bloomberg-logo.55fb42c8.png";